import words from './words.json';

function getRandomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function generateWords(numberOfWords = 12) {
    let set = new Set();
    let list = [];
    let index;
    for (let i = 0; i < numberOfWords; i++) {
        index = getRandomInteger(0, words.length - 1);
        if (set.has(index)) {
            i--;
            continue;
        }
        list.push(words[index]);
        set.add(index);
    }
    return list;
}

export default generateWords;
